/* Product cards (home, collections, search): when a product's 2nd media is a video.
   DESKTOP (mouse): plays on mouse-over, muted and looping, stops when the mouse leaves. 4 Oct 2026.
   PHONES / TABLETS (touch): NO autoplay any more (16 Oct 2026, owner: several cards animating at once is too much).
   Each animated card shows a small "Play" button; a tap starts that one animation (only one at a time), a second tap or
   scrolling it away stops it. The tap never opens the product page. Needs the card to output its <video> (the snippet does). */
(function () {
  var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var st = document.createElement('style');
  st.textContent = '.card__hover-video{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:0;' +
    'transition:opacity .25s ease;pointer-events:none;z-index:2}.card__hover-video.is-playing{opacity:1}' +
    '.card__media:has(.card__hover-video){-webkit-mask-image:-webkit-radial-gradient(white,black);mask-image:radial-gradient(white,black)}' +
    '.card__play-badge{position:absolute;left:0;top:0;z-index:5;display:inline-flex;align-items:center;gap:6px;' +
    'min-height:34px;padding:6px 12px 6px 10px;border:0;border-radius:999px;background:rgba(17,17,17,.68);color:#fff;' +
    'font:inherit;font-size:13px;font-weight:600;line-height:1;cursor:pointer;-webkit-tap-highlight-color:transparent;' +
    'touch-action:manipulation}.card__play-badge svg{width:12px;height:12px;fill:currentColor;flex:none}' +
    '.card__play-badge .is-stop{display:none}.card__play-badge.is-on .is-play{display:none}.card__play-badge.is-on .is-stop{display:inline}' +
    '.card__play-badge .lbl-stop{display:none}.card__play-badge.is-on .lbl-play{display:none}.card__play-badge.is-on .lbl-stop{display:inline}';
  document.head.appendChild(st);

  function start(v) {
    if (!v.getAttribute('src') && v.dataset.hoverSrc) v.src = v.dataset.hoverSrc;
    // a playing video is its own layer and ignores the card's rounded clip: give it the same corners
    var m = v.closest('.card__media');
    if (m) {
      var r = getComputedStyle(m).borderRadius;
      v.style.borderRadius = r;
      v.style.clipPath = 'inset(0 round ' + r + ')';
    }
    v.muted = true;
    v.loop = true;
    v.addEventListener('playing', function () { v.classList.add('is-playing'); }, { once: true });
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
    if (!v.paused && v.readyState > 2) v.classList.add('is-playing');
  }
  function stop(v) {
    v.pause();
    v.classList.remove('is-playing');
    try { v.currentTime = 0; } catch (e) {}
  }
  if (!canHover) {
    // Touch screens: a Play button on every animated card, one animation at a time.
    var current = null, seen = new WeakSet();
    var setBadge = function (v, on) {
      var b = v && v._badge; if (!b) return;
      b.classList.toggle('is-on', !!on);
      b.setAttribute('aria-label', on ? 'Stop animation' : 'Play animation');
    };
    var halt = function (v) { if (!v) return; stop(v); setBadge(v, false); if (current === v) current = null; };
    var addBadge = function (v) {
      var box = v.closest('.card__media');
      var inner = v.closest('.card__inner') || box;
      var host = v.closest('.card-wrapper');      // the card has a link laid over it and the picture is its own layer: the button lives on the card itself, above both, and is placed over the picture's corner
      if (!box || !inner || !host || host.querySelector('.card__play-badge')) return;
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'card__play-badge'; b.setAttribute('aria-label', 'Play animation');
      b.innerHTML = '<svg class="is-play" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1l9 5-9 5z"/></svg>' +
        '<svg class="is-stop" viewBox="0 0 12 12" aria-hidden="true"><path d="M2 1h3v10H2zM7 1h3v10H7z"/></svg>' +
        '<span class="lbl-play">Play</span><span class="lbl-stop">Stop</span>';
      v._badge = b; host.appendChild(b);
      var place = function () {
        var ir = inner.getBoundingClientRect(), hr = host.getBoundingClientRect();
        b.style.left = Math.round(ir.right - hr.left - b.offsetWidth - 8) + 'px';
        b.style.top = Math.round(ir.bottom - hr.top - b.offsetHeight - 8) + 'px';
      };
      place();
      if ('ResizeObserver' in window) new ResizeObserver(place).observe(inner);
      window.addEventListener('resize', place); window.addEventListener('load', place);
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();          // never follow the card link
        if (current === v) { halt(v); return; }
        halt(current);
        v.setAttribute('playsinline', '');
        start(v); setBadge(v, true); current = v;
      });
      // scrolling the card away stops its animation
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (en) { if (!en.isIntersecting && current === v) halt(v); });
        }, { threshold: 0.1 }).observe(box);
      }
    };
    var scan = function () {
      document.querySelectorAll('.card__hover-video').forEach(function (v) {
        if (seen.has(v)) return; seen.add(v); addBadge(v);
      });
    };
    scan();
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
    return;
  }
  document.addEventListener('mouseover', function (e) {
    var w = e.target.closest && e.target.closest('.card-wrapper');
    var v = w && w.querySelector('.card__hover-video');
    if (v) start(v);
  });
  document.addEventListener('mouseout', function (e) {
    var w = e.target.closest && e.target.closest('.card-wrapper');
    if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    var v = w.querySelector('.card__hover-video');
    if (v) stop(v);
  });
})();
